var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_Gradient",
    x1: -20.83,
    y1: 131.69,
    x2: -20.83,
    y2: -18.31,
    gradientTransform: "translate(92.31 12.14) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e27ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AWS-Cloud-Development-Kit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Working"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Green_Gradient",
    "data-name": "Green Gradient",
    width: 75,
    height: 75,
    style: {
      fill: "url(#Blue_Gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,47h0l-8.49-4.75V32.9A1,1,0,0,0,47,32h0l-9-5a1,1,0,0,0-1,0l-9,5h0a1,1,0,0,0-.49.86v9.37L19,47h0a1,1,0,0,0-.49.87v11a1,1,0,0,0,.5.87l9,5.13h0a1.05,1.05,0,0,0,.49.13,1.13,1.13,0,0,0,.5-.13L37.51,60l8.54,4.76h0a1.05,1.05,0,0,0,.49.13.94.94,0,0,0,.48-.13l9-5a1,1,0,0,0,.51-.87v-11A1,1,0,0,0,56,47ZM29.54,34.62l7,3.87v7.69l-7-3.89Zm16,7.65-7,3.91V38.5l7-3.9Zm-7,7.32,7,4v8.65l-7-3.92Zm1-1.7,7-3.88,7,3.9-6.94,3.92Zm-2-18.84,6.93,3.85-7,3.86-6.91-3.84Zm-17,20.56,7,3.92v8.76l-7-4Zm8,2.18-7-3.88,7-3.89,6.92,3.86Zm8,6.5-7,4V53.52l7-3.93Zm18,0-7,3.89V53.56l7-3.94Zm11.19-22A10.26,10.26,0,0,1,58.1,46.68l-.61-1.91a8.26,8.26,0,0,0,6.22-8.46c0-6.8-5.6-8.49-8-8.91a1,1,0,0,1-.82-1.13h0c-.24-3.1-1.69-5.32-3.89-6a4.62,4.62,0,0,0-5,1.81,1,1,0,0,1-1.75-.26A15.5,15.5,0,0,0,40.66,16,12.7,12.7,0,0,0,26.23,13.1c-4.24,1.79-7.56,7-7.56,11.77a14.35,14.35,0,0,0,.09,1.61A1,1,0,0,1,18,27.56a8.36,8.36,0,0,0-6.73,8.66c0,.2,0,.39,0,.58a8.89,8.89,0,0,0,7,8.13l-.45,1.94a10.88,10.88,0,0,1-8.51-10c0-.22,0-.45,0-.68A10.22,10.22,0,0,1,16.7,25.87c0-.33,0-.67,0-1,0-5.64,3.77-11.5,8.78-13.62a14.72,14.72,0,0,1,16.63,3.31,16.94,16.94,0,0,1,3.45,5.13,6.51,6.51,0,0,1,6-1.31c2.9.85,4.84,3.52,5.28,7.21C59.66,26.25,65.71,28.58,65.71,36.31Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdk);
export default __webpack_public_path__ + "static/media/cdk.9d939377db851cea973214cb0977f874.svg";
export { ForwardRef as ReactComponent };